// Performans (2026-09-04): "Kendi Kutunu Yap" 2. adımında step2_collections'daki
// TÜM kategorilerin ürünleri artık ilk sayfa yüklemesinde DOM'a basılmıyor -
// yalnızca ilk kategori sunucu tarafında hazır geliyor (bkz.
// templates/collection.custom-step.liquid). Geri kalan kategoriler boş bir
// kutu (data-loaded="false") olarak duruyor; bu dosya onları ya kullanıcı
// soldaki menüden ilgili kategoriye tıklayınca ya da doğal kaydırmayla o
// bölgeye yaklaşınca, templates/collection.step-ajax.liquid şablonunun
// ürettiği parçayı fetch'leyip yerine koyarak dolduruyor.
//
// Kaydırma sıçraması (2026-09-05): kategori değiştirirken ya da "Daha Fazla
// Yükle"ye basınca konum milisaniyeler içinde başka bir yere kayabiliyordu.
// Tam sebebi cihaza göre değişiyor olabilir (görsellerin geç boyutlanması,
// Safari'nin overflow-anchor'ı hiç desteklememesi, vb.) - kesin sebebi
// kovalamak yerine SONUCU garantiye alıyoruz: hedefe zıpladıktan/butona
// bastıktan sonra konum bir süre boyunca (~1.2sn, her karede) izleniyor ve
// kaymışsa geri düzeltiliyor. Kullanıcı bu sırada kendisi dokunur/kaydırırsa
// düzeltme anında bırakılıyor - onunla yarışmıyor.
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".kendi-kutunu-yap-wrapper");
  if (!wrapper) return;

  // Kullanıcı kendisi dokunur/tekerlek çevirirse düzeltme döngüleri hemen
  // vazgeçsin diye paylaşılan bir "nesil" sayacı - her kullanıcı etkileşimi
  // sayacı artırır, o ana kadar başlamış her düzeltme döngüsü kendi aldığı
  // eski numarayı görüp durur.
  let interactionGeneration = 0;
  ["touchstart", "wheel", "pointerdown"].forEach(function (evt) {
    window.addEventListener(
      evt,
      function () {
        interactionGeneration++;
      },
      { passive: true }
    );
  });

  // Referans elemanın ekrandaki (viewport'a göre) üst konumunu `targetTop`'a
  // sabitlemeye çalışır - her animasyon karesinde ölçüp sapmayı telafi eder.
  // durationMs boyunca (ya da kullanıcı araya girene kadar) sürer.
  function driveToPosition(referenceEl, targetTop, durationMs) {
    if (!referenceEl) return;
    const myGeneration = ++interactionGeneration;
    const deadline = performance.now() + durationMs;
    const html = document.documentElement;

    function tick() {
      if (interactionGeneration !== myGeneration) return; // kullanıcı araya girdi
      if (!referenceEl.isConnected) return;

      const delta = referenceEl.getBoundingClientRect().top - targetTop;
      if (Math.abs(delta) > 1) {
        const previous = html.style.scrollBehavior;
        html.style.scrollBehavior = "auto";
        window.scrollBy(0, delta);
        html.style.scrollBehavior = previous;
      }

      if (performance.now() < deadline) {
        requestAnimationFrame(tick);
      }
    }
    requestAnimationFrame(tick);
  }

  // Kategori zıplaması: hedefi ekranın en üstüne (top:0) sabitler.
  function jumpToCategory(target) {
    driveToPosition(target, 0, 1200);
  }

  // "Daha Fazla Yükle": kullanıcının o an baktığı referans noktayı (mutasyon
  // öncesi kaydedilen viewport konumunu) korur - hiçbir yere zıplamaz.
  function holdPosition(referenceEl, savedTop) {
    if (savedTop === null) return;
    driveToPosition(referenceEl, savedTop, 1200);
  }

  function getLazyContainer(collectionId) {
    return wrapper.querySelector(
      `.hediye-product-list[data-collection-id="${CSS.escape(collectionId)}"]`
    );
  }

  const pendingLoads = new Map();

  function loadCategory(container) {
    if (!container || container.dataset.loaded === "true") {
      return Promise.resolve();
    }

    const existing = pendingLoads.get(container);
    if (existing) return existing;

    const handle = container.getAttribute("data-collection-handle");
    if (!handle) return Promise.resolve();

    const promise = fetch(`/collections/${handle}?view=step-ajax`)
      .then((response) => {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.text();
      })
      .then((html) => {
        container.innerHTML = html;
        container.dataset.loaded = "true";
      })
      .catch((error) => {
        console.error("Kategori yüklenemedi:", handle, error);
        container.innerHTML =
          '<div class="category-load-error">Bu kategori yüklenemedi. ' +
          '<button type="button" class="category-retry-btn">Tekrar dene</button></div>';
        const retryBtn = container.querySelector(".category-retry-btn");
        if (retryBtn) {
          retryBtn.addEventListener("click", function () {
            container.innerHTML = '<div class="category-loading-placeholder">Yükleniyor…</div>';
            pendingLoads.delete(container);
            loadCategory(container);
          });
        }
      })
      .finally(() => {
        pendingLoads.delete(container);
      });

    pendingLoads.set(container, promise);
    return promise;
  }

  // Elle kaydırma: kategori görünüme yaklaşınca arka planda yükle.
  let categoryObserver = null;
  const lazyContainers = wrapper.querySelectorAll(
    '.hediye-product-list[data-loaded="false"]'
  );
  const supportsObserver = "IntersectionObserver" in window;
  if (supportsObserver && lazyContainers.length > 0) {
    categoryObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadCategory(entry.target);
          categoryObserver.unobserve(entry.target);
        });
      },
      { rootMargin: "600px 0px 600px 0px" }
    );
    lazyContainers.forEach(function (container) {
      categoryObserver.observe(container);
    });
  } else if (!supportsObserver) {
    // IntersectionObserver yoksa (çok eski tarayıcı) güvenli varsayılan:
    // hepsini yükle, en azından işlevsellik bozulmasın.
    lazyContainers.forEach(loadCategory);
  }

  function pauseObserverThenResume(afterMs) {
    if (categoryObserver) categoryObserver.disconnect();
    if (!categoryObserver) return;
    setTimeout(function () {
      wrapper
        .querySelectorAll('.hediye-product-list[data-loaded="false"]')
        .forEach(function (remaining) {
          categoryObserver.observe(remaining);
        });
    }, afterMs);
  }

  // Soldaki kategori menüsüne tıklama: hedef kategori henüz yüklenmediyse
  // önce yükle, sonra zıpla - aradaki kategoriler hiç render edilmez.
  // Tıklama anında observer'ı bilerek durduruyoruz (bkz. yukarıdaki not) -
  // aksi halde "elle kaydırma" gözlemcisi tam biz zıplarken başka
  // kategorileri de arka planda yükleyip sayfa yüksekliğini değiştirebilir.
  wrapper.addEventListener("click", function (e) {
    const link = e.target.closest('.headers a[href^="#"]');
    if (!link) return;

    const targetId = link.getAttribute("href").slice(1);
    if (!targetId) return;

    const container = getLazyContainer(targetId);
    // Bu bir kategori linki değilse (ör. "#kutular") ya da zaten yüklüyse
    // varsayılan çapa davranışına karışma.
    if (!container || container.dataset.loaded === "true") return;

    e.preventDefault();
    pauseObserverThenResume(500);

    loadCategory(container).finally(function () {
      jumpToCategory(document.getElementById(targetId));
    });
  });

  // "Daha Fazla Yükle" (bir kategoride 24/50'den fazla ürün olduğunda çıkan
  // sayfalama butonu) - önceden hiçbir JS'e bağlı değildi, tıklanınca hiçbir
  // şey olmuyordu. Hem ilk (eager) kategorinin hem de lazy-load edilen bir
  // kategorinin kendi "sonraki sayfa" butonu için tek noktadan çalışır.
  // paginate.next.url, ilk (eager) kategoride sayfanın KENDİ koleksiyonunun
  // adresini üretiyor (ör. /collections/kendi-kutunu-yap?page=2), döngüdeki
  // kategorinin değil - bu yüzden yalnızca "page" numarasını alıp yolu
  // kategorinin kendi handle'ından kuruyoruz.
  function toAjaxUrl(url, handle) {
    const u = new URL(url, location.origin);
    const page = u.searchParams.get("page");
    const path = handle ? "/collections/" + encodeURIComponent(handle) : u.pathname;
    const out = new URL(path, location.origin);
    if (page) out.searchParams.set("page", page);
    out.searchParams.set("view", "step-ajax");
    return out.pathname + out.search;
  }

  wrapper.addEventListener("click", function (e) {
    const btn = e.target.closest(".load-more-btn");
    if (!btn || btn.disabled) return;

    const nextPage = btn.getAttribute("data-next-page");
    const collectionId = btn.getAttribute("data-collection-id");
    const container = collectionId ? getLazyContainer(collectionId) : null;
    if (!nextPage || !container) return;

    e.preventDefault();
    pauseObserverThenResume(500);

    // Kullanıcının o an baktığı referans nokta: hâlihazırda yüklü son ürün
    // kartı - yeni ürünler bunun ARDINDAN eklenecek, bu kart hep DOM'da
    // kalacak. Mutasyon öncesi ekrandaki konumunu kaydedip sonra aynı yerde
    // tutmaya çalışıyoruz (butonun kendisi replace/remove olabileceği için
    // referans olarak kullanılamıyor).
    const existingItems = container.querySelectorAll(".product-list-item");
    const referenceEl = existingItems.length
      ? existingItems[existingItems.length - 1]
      : null;
    const savedTop = referenceEl ? referenceEl.getBoundingClientRect().top : null;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = "Yükleniyor…";

    fetch(toAjaxUrl(nextPage, container.getAttribute("data-collection-handle")))
      .then((response) => {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.text();
      })
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        // Yeni gelen ürün kartlarını butonun hemen önüne ekle.
        temp.querySelectorAll(".product-list-item").forEach(function (item) {
          container.insertBefore(item, btn);
        });

        // Yeni parçada da bir "sonraki sayfa" butonu varsa eskisinin yerine
        // geçsin, yoksa mevcut sayfalama burada bitmiş demektir.
        const nextBtn = temp.querySelector(".load-more-btn");
        if (nextBtn) {
          btn.replaceWith(nextBtn);
        } else {
          btn.remove();
        }

        if (referenceEl) holdPosition(referenceEl, savedTop);
      })
      .catch((error) => {
        console.error("Daha fazla ürün yüklenemedi:", error);
        btn.disabled = false;
        btn.textContent = originalText;
        alert("Daha fazla ürün yüklenemedi, lütfen tekrar deneyin.");
      });
  });

  // Sayfa doğrudan bir kategori çapasıyla açıldıysa (derin bağlantı) o
  // kategoriyi hemen yükleyip oraya zıpla.
  if (location.hash) {
    const targetId = location.hash.slice(1);
    const container = getLazyContainer(targetId);
    if (container) {
      pauseObserverThenResume(500);
      loadCategory(container).finally(function () {
        jumpToCategory(document.getElementById(targetId));
      });
    }
  }
});
